export default __webpack_public_path__ + "static/media/allrmaid.6fe21dcd.jpg";